export const objectToBlob = (obj: unknown) =>
  new Blob([JSON.stringify(obj)], { type: 'application/json' })
export const blobToObject = async (blob: Blob): Promise<unknown> =>
  JSON.parse(await blob.text())

export const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

export const isString = (value: unknown): value is string =>
  typeof value === 'string'

export const isObjectOrArray = (
  value: unknown,
): value is Record<string, unknown> | unknown[] =>
  typeof value === 'object' && value !== null
